/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'
import Layout from './components/Layout/Layout'
import "@fontsource/maven-pro"
import { ThemeProvider } from '@mui/material/styles';


import themes from './themes';
import { HelmetProvider } from 'react-helmet-async';
import { NetworkProvider } from './utils/network'; 
const customization = {
    borderRadius: 10,
    fontFamily: "'Roboto', sans-serif",
    locale: "en",
    mode: "dark",
};




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <HelmetProvider>
            <BrowserRouter >


                <ThemeProvider theme={themes(customization)} >
                    <NetworkProvider>
                        <Layout>
                            <App />
                        </Layout>
                    </NetworkProvider>
                </ThemeProvider>
            </BrowserRouter>
        </HelmetProvider>
    </Provider >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
